/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RansomwareRecoveryEdrVendorEnum = 'CARBON_BLACK' | 'CROWDSTRIKE';

export const RansomwareRecoveryEdrVendorEnum = {

    CARBON_BLACK: 'CARBON_BLACK' as RansomwareRecoveryEdrVendorEnum,

    CROWDSTRIKE: 'CROWDSTRIKE' as RansomwareRecoveryEdrVendorEnum
};

